import React from "react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
  Form,
  FormGroup,
  Badge,
} from "reactstrap";

import axios from "axios";
import { useState, useEffect } from "react";
import { API_TIMEOUT } from "utils";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import { API_DONOR_DARAH } from "utils";
import { logApp } from "utils/func";

function WablasSettings() {
  const [tabelWablas, setTabelWablas] = useState([]);
  const [modalFormOpen, setModalFormOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [formData, setFormData] = useState({
    nama: "",
    url: "",
    tokenwhatsapp: "",
    secret_key: "",
    is_active: 0,
  });
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentUser, setCurrentUser] = useState("");
  const history = useHistory();

  useEffect(() => {
    if (!currentUser) {
      let user = localStorage.getItem("user");
      if (user) {
        user = JSON.parse(user);
        logApp(user.uid, "Wablas Settings");
        setCurrentUser(user);
      } else {
        history.push("/login");
      }
    }
  }, []);

  useEffect(() => {
    if (currentUser) {
      ambilDataWablas();
    }
  }, [currentUser]);

  const ambilDataWablas = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_DONOR_DARAH}wablas`, {
        timeout: API_TIMEOUT,
      });

      if (response.data?.success) {
        setTabelWablas(response.data.data || []);
      } else {
        swal("Error", "Gagal mengambil data wablas", "error");
      }
    } catch (error) {
      console.error("Error fetching wablas data:", error);
      swal("Error", "Gagal mengambil data wablas", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModal = (edit = false, data = null) => {
    setIsEdit(edit);
    if (edit && data) {
      setSelectedId(data.id);
      setFormData({
        nama: data.nama || "",
        url: data.url || "",
        tokenwhatsapp: data.tokenwhatsapp || "",
        secret_key: data.secret_key || "",
        is_active: data.is_active || 0,
      });
    } else {
      setSelectedId(null);
      setFormData({
        nama: "",
        url: "",
        tokenwhatsapp: "",
        secret_key: "",
        is_active: 0,
      });
    }
    setErrors({});
    setModalFormOpen(true);
  };

  const handleCloseModal = () => {
    setModalFormOpen(false);
    setIsEdit(false);
    setSelectedId(null);
    setFormData({
      nama: "",
      url: "",
      tokenwhatsapp: "",
      secret_key: "",
      is_active: 0,
    });
    setErrors({});
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.url || formData.url.trim() === "") {
      newErrors.url = "URL harus diisi";
    } else if (
      !formData.url.startsWith("http://") &&
      !formData.url.startsWith("https://")
    ) {
      newErrors.url = "URL harus dimulai dengan http:// atau https://";
    }

    if (!formData.tokenwhatsapp || formData.tokenwhatsapp.trim() === "") {
      newErrors.tokenwhatsapp = "Token WhatsApp harus diisi";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setSaving(true);

    try {
      const dataToSend = {
        nama: formData.nama ? formData.nama.trim() : null,
        url: formData.url.trim(),
        tokenwhatsapp: formData.tokenwhatsapp.trim(),
        secret_key: formData.secret_key ? formData.secret_key.trim() : null,
        is_active: formData.is_active ? 1 : 0,
      };

      let response;
      if (isEdit) {
        response = await axios.put(
          `${API_DONOR_DARAH}wablas/${selectedId}`,
          dataToSend,
          { timeout: API_TIMEOUT }
        );
      } else {
        response = await axios.post(`${API_DONOR_DARAH}wablas`, dataToSend, {
          timeout: API_TIMEOUT,
        });
      }

      if (response.data?.success) {
        swal(
          "Berhasil",
          isEdit
            ? "Data wablas berhasil diupdate"
            : "Data wablas berhasil ditambahkan",
          "success"
        );
        handleCloseModal();
        ambilDataWablas();
      } else {
        swal(
          "Error",
          response.data?.message || "Gagal menyimpan data",
          "error"
        );
      }
    } catch (error) {
      console.error("Error saving wablas data:", error);
      swal(
        "Error",
        error.response?.data?.message || "Gagal menyimpan data",
        "error"
      );
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = (id) => {
    swal({
      title: "Hapus Data?",
      text: "Data yang dihapus tidak dapat dikembalikan!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const response = await axios.delete(
            `${API_DONOR_DARAH}wablas/${id}`,
            { timeout: API_TIMEOUT }
          );

          if (response.data?.success) {
            swal("Berhasil", "Data wablas berhasil dihapus", "success");
            ambilDataWablas();
          } else {
            swal(
              "Error",
              response.data?.message || "Gagal menghapus data",
              "error"
            );
          }
        } catch (error) {
          console.error("Error deleting wablas data:", error);
          swal("Error", "Gagal menghapus data", "error");
        }
      }
    });
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <CardTitle tag="h4">
                    Pengaturan Wablas (WhatsApp API)
                  </CardTitle>
                  <Button
                    color="primary"
                    size="sm"
                    onClick={() => handleOpenModal(false)}
                  >
                    <i className="fas fa-plus" style={{ marginRight: "5px" }} />
                    Tambah Data
                  </Button>
                </div>
              </CardHeader>
              <CardBody>
                {loading ? (
                  <div className="text-center" style={{ padding: "50px" }}>
                    <i className="fas fa-spinner fa-spin fa-3x"></i>
                    <p style={{ marginTop: "20px" }}>Memuat data...</p>
                  </div>
                ) : tabelWablas.length === 0 ? (
                  <div className="text-center" style={{ padding: "50px" }}>
                    <p>Tidak ada data wablas</p>
                    <Button
                      color="primary"
                      size="sm"
                      onClick={() => handleOpenModal(false)}
                    >
                      Tambah Data Pertama
                    </Button>
                  </div>
                ) : (
                  <Table responsive>
                    <thead className="text-primary">
                      <tr>
                        <th>No</th>
                        <th>Nama</th>
                        <th>URL</th>
                        <th>Token WhatsApp</th>
                        <th>Secret Key</th>
                        <th>Status</th>
                        <th>Created At</th>
                        <th>Updated At</th>
                        <th>Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tabelWablas.map((item, index) => (
                        <tr key={item.id}>
                          <td>{index + 1}</td>
                          <td>
                            <div
                              style={{
                                maxWidth: "200px",
                                wordBreak: "break-word",
                                fontWeight: "500",
                              }}
                            >
                              {item.nama || "-"}
                            </div>
                          </td>
                          <td>
                            <div
                              style={{
                                maxWidth: "300px",
                                wordBreak: "break-word",
                              }}
                            >
                              {item.url}
                            </div>
                          </td>
                          <td>
                            <div
                              style={{
                                maxWidth: "200px",
                                wordBreak: "break-word",
                                fontFamily: "monospace",
                                fontSize: "0.85rem",
                              }}
                            >
                              {item.tokenwhatsapp || "-"}
                            </div>
                          </td>
                          <td>
                            <div
                              style={{
                                maxWidth: "200px",
                                wordBreak: "break-word",
                                fontFamily: "monospace",
                                fontSize: "0.85rem",
                              }}
                            >
                              {item.secret_key || "-"}
                            </div>
                          </td>
                          <td>
                            {item.is_active === 1 ? (
                              <Badge color="success">Aktif</Badge>
                            ) : (
                              <Badge color="secondary">Nonaktif</Badge>
                            )}
                          </td>
                          <td>
                            {item.createdAt
                              ? new Date(item.createdAt).toLocaleString("id-ID")
                              : "-"}
                          </td>
                          <td>
                            {item.updatedAt
                              ? new Date(item.updatedAt).toLocaleString("id-ID")
                              : "-"}
                          </td>
                          <td>
                            <Button
                              color="info"
                              size="sm"
                              style={{ marginRight: "5px" }}
                              onClick={() => handleOpenModal(true, item)}
                            >
                              <i className="fas fa-edit"></i>
                            </Button>
                            <Button
                              color="danger"
                              size="sm"
                              onClick={() => handleDelete(item.id)}
                            >
                              <i className="fas fa-trash"></i>
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Modal Form */}
        <Modal isOpen={modalFormOpen} toggle={handleCloseModal} size="lg">
          <ModalHeader toggle={handleCloseModal}>
            {isEdit ? "Edit Data Wablas" : "Tambah Data Wablas"}
          </ModalHeader>
          <Form onSubmit={handleSubmit}>
            <ModalBody>
              <FormGroup>
                <Label>Nama Konfigurasi</Label>
                <Input
                  type="text"
                  placeholder="Contoh: Konfigurasi Utama, Backup, dll"
                  value={formData.nama}
                  onChange={(e) =>
                    setFormData({ ...formData, nama: e.target.value })
                  }
                />
                <small className="form-text text-muted">
                  Nama untuk mengidentifikasi konfigurasi ini (opsional)
                </small>
              </FormGroup>

              <FormGroup>
                <Label>
                  URL API Wablas <span style={{ color: "red" }}>*</span>
                </Label>
                <Input
                  type="text"
                  placeholder="https://pati.wablas.com/api/send-message"
                  value={formData.url}
                  onChange={(e) =>
                    setFormData({ ...formData, url: e.target.value })
                  }
                  invalid={!!errors.url}
                />
                {errors.url && (
                  <div className="invalid-feedback d-block">{errors.url}</div>
                )}
                <small className="form-text text-muted">
                  Masukkan URL lengkap API Wablas (contoh:
                  https://pati.wablas.com/api/send-message)
                </small>
              </FormGroup>

              <FormGroup>
                <Label>
                  Token WhatsApp <span style={{ color: "red" }}>*</span>
                </Label>
                <Input
                  type="textarea"
                  rows={3}
                  placeholder="Masukkan token WhatsApp"
                  value={formData.tokenwhatsapp}
                  onChange={(e) =>
                    setFormData({ ...formData, tokenwhatsapp: e.target.value })
                  }
                  invalid={!!errors.tokenwhatsapp}
                />
                {errors.tokenwhatsapp && (
                  <div className="invalid-feedback d-block">
                    {errors.tokenwhatsapp}
                  </div>
                )}
                <small className="form-text text-muted">
                  Masukkan token autentikasi dari Wablas
                </small>
              </FormGroup>

              <FormGroup>
                <Label>Secret Key</Label>
                <Input
                  type="text"
                  placeholder="Masukkan secret key (opsional)"
                  value={formData.secret_key}
                  onChange={(e) =>
                    setFormData({ ...formData, secret_key: e.target.value })
                  }
                />
                <small className="form-text text-muted">
                  Masukkan secret key untuk autentikasi tambahan (opsional)
                </small>
              </FormGroup>

              <FormGroup>
                <Label check>
                  <Input
                    type="checkbox"
                    checked={formData.is_active === 1}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        is_active: e.target.checked ? 1 : 0,
                      })
                    }
                  />
                  <span style={{ marginLeft: "10px" }}>
                    Aktifkan konfigurasi ini
                  </span>
                </Label>
                <small className="form-text text-muted">
                  Hanya satu konfigurasi yang dapat aktif. Mengaktifkan ini akan
                  menonaktifkan konfigurasi lain.
                </small>
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Button
                color="secondary"
                onClick={handleCloseModal}
                disabled={saving}
              >
                Batal
              </Button>
              <Button color="primary" type="submit" disabled={saving}>
                {saving ? (
                  <>
                    <i
                      className="fas fa-spinner fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                    Menyimpan...
                  </>
                ) : isEdit ? (
                  "Update"
                ) : (
                  "Simpan"
                )}
              </Button>
            </ModalFooter>
          </Form>
        </Modal>
      </div>
    </>
  );
}

export default WablasSettings;
